import { graphql } from "gql.tada";
import { RichTextFragment } from "@queries/fragments/RichTextFragment";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

const SolutionsRowFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsRowInlineFragment on SolutionsChapterRow {
      _id
      title
      eyebrow
      rowType
      collapsible
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      bodyRichText {
        ...RichTextFragment
      }
    }
  `,
  [LinkFragment, RichTextFragment]
);

const SolutionsChapterFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsChapterInlineFragment on SolutionsChapter {
      _id
      title
      eyebrow
      menuLabel
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      media {
        url
        contentType
      }
      mediaSourceRichText {
        ...RichTextFragment
      }
      mediaBodyRichText {
        ...RichTextFragment
      }
      mediaHeading
      mediaLayout
      iconGrid {
        ...IconGridFragment
      }
      rowsCollection(limit: 10) {
        items {
          ...SolutionsRowInlineFragment
        }
      }
    }
  `,
  [SolutionsRowFragment, IconGridFragment, RichTextFragment]
);

export const GetProductPageById = graphql(
  `
    query GetProductPageById($id: String!, $locale: String, $preview: Boolean) {
      productPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        hero {
          variant
          title
          subtitle
          description
          ctaText
          ctaLink
          backgroundImage {
            url
            contentType
          }
          previewVideo {
            url
            contentType
          }
          fullVideo {
            url
            contentType
          }
          overlayImage {
            url
          }
          eyebrowImagesCollection {
            items {
              url
              contentType
            }
          }
          bodyRichText {
            ...RichTextFragment
          }
          fullWidthImage {
            url
            contentType
          }
        }
        solutions {
          _id
          title
          chaptersCollection(limit: 6) {
            items {
              ...SolutionsChapterInlineFragment
            }
          }
        }
        routing {
          sys {
            id
          }
          variant
          isVertical
          title
          titleRichText {
            json
          }
          cta {
            ...LinkFragment
          }
          backgroundImage {
            url
            title
          }
        }
        legal {
          __typename
          ... on TwoColumnRichTextSection {
            _id
            leftColumnRichText {
              ...RichTextFragment
            }
            rightColumnRichText {
              ...RichTextFragment
            }
          }
        }
      }
    }
  `,
  [RichTextFragment, LinkFragment, SolutionsChapterFragment, IconGridFragment, ThemeFragment, MetadataFragment]
);
